import { List } from 'immutable';

import State from '../core/State';
import YoutubeChannel from '../entity/YoutubeChannel';
import initialState from '../initialState';

export const setYoutubeChannels = (channels: List<YoutubeChannel>) => (state: State): State => ({
  ...state,
  youtubeChannels: channels,
});

export const addYoutubeChannel = (channel: YoutubeChannel) => (state: State): State => ({
  ...state,
  youtubeChannels: state.youtubeChannels.push(channel),
});

export const disposeYoutubeChannel = (channel: YoutubeChannel) => (state: State): State => ({
  ...state,
  youtubeChannels: state.youtubeChannels.filter((v) => {
    return v.channelId !== channel.channelId;
  }),
});

export const disposeYoutubeChannels = () => (state: State): State => ({
  ...state,
  youtubeChannels: initialState.youtubeChannels,
});
